// Menu por PERFIL, no padrão ORIGINAL (seções colapsáveis) + itens NOVOS (badge "novo").
// Estrutura recuperada do bundle original (XE=admin, KE=licenciado, ZE=cliente),
// acrescida das telas do backend já atualizado (Produtos, Serviços, Catálogo, Pedidos,
// Meu Link/Loja, Qualificações, Parâmetros MLM, Gerador de Flyer).
import {
  LayoutDashboard, Briefcase, Users, Zap, Package, Wrench, Tags,
  Link2, ShoppingCart, ClipboardList, Calculator, UserCog, Award, SlidersHorizontal,
  Share2, Network, Store, Receipt, DollarSign, BookOpen, Image, CreditCard,
  MessageCircle, Mail, Plug, Trophy, LifeBuoy, Wallet, Gift, FileText, Sparkles,
  Handshake, UploadCloud, Search, ScrollText, BarChart3, Landmark, GraduationCap, Banknote,
  Bell, Megaphone, ShieldCheck, Car, Smartphone, IdCard,
} from 'lucide-react'

export const PUBLIC_ROUTES = [
  { path: '/login', label: 'Login' },
  { path: '/loja/:codigo', label: 'Loja pública' },
  { path: '/aceite/:token', label: 'Termo de aceite' },
  { path: '/indicacao/:codigo', label: 'Cadastro via indicação' },
]

// Item de topo (acima das seções), igual ao original.
export const DASHBOARD_ITEM = { label: 'Dashboard', path: '/dashboard', icon: LayoutDashboard }

// Seções RECOLHIDAS por padrão ao entrar (usuário expande o que quiser).
export const DEFAULT_OPEN = []

const N = 'novo'

const ADMIN = [
  {
    section: 'Cadastro',
    items: [
      { label: 'Licenciados', path: '/cadastro/licenciados', icon: Briefcase },
      { label: 'Clientes', path: '/cadastro/clientes', icon: Users },
      { label: 'Distribuidoras', path: '/cadastro/distribuidoras', icon: Zap },
      { label: 'Geradoras (Energia GD)', path: '/cadastro/geradoras', icon: Zap, badge: N },
      { label: 'Parceiros / Fornecedores', path: '/cadastro/parceiros', icon: Handshake, badge: N },
      { label: 'Produtos', path: '/cadastro/produtos', icon: Package, badge: N },
      { label: 'Serviços', path: '/cadastro/servicos', icon: Wrench, badge: N },
      { label: 'Catálogo / Ofertas', path: '/cadastro/ofertas', icon: Tags, badge: N },
    ],
  },
  {
    section: 'Registros de Conexão',
    items: [
      { label: 'Conexão', path: '/registros/conexao', icon: Link2 },
      { label: 'Fazer Pedidos', path: '/registros/pedidos', icon: ShoppingCart, badge: N },
      { label: 'Faturas (Recorrência)', path: '/registros/faturas', icon: Receipt, badge: N },
      { label: 'Fila de Análise', path: '/registros/fila-analise', icon: ClipboardList },
      { label: 'Fila de Conexão', path: '/registros/fila-conexao', icon: Network, badge: N },
      { label: 'Proteção Veicular', path: '/registros/protecao-veicular', icon: ShieldCheck, badge: N },
      { label: 'Proteção Veicular — Gestão', path: '/registros/protecao-veicular/gestao', icon: Car, badge: N },
      { label: 'Telecom', path: '/registros/telecom', icon: Smartphone, badge: N },
    ],
  },
  {
    section: 'Financeiro / Faturas',
    items: [
      { label: 'Painel Financeiro (Executivo)', path: '/financeiro/admin', icon: Landmark, badge: N },
      { label: 'Painel de Faturas', path: '/financeiro/painel', icon: BarChart3, badge: N },
      { label: 'Faturas Pagas', path: '/financeiro/faturas-pagas', icon: Receipt, badge: N },
      { label: 'Importar Faturas', path: '/financeiro/importar', icon: UploadCloud, badge: N },
      { label: 'Busca Administrativa', path: '/financeiro/busca', icon: Search, badge: N },
      { label: 'Tesouraria · Liberação & Saques', path: '/financeiro/tesouraria', icon: Landmark, badge: N },
      { label: 'Gestão de Saques (em massa)', path: '/financeiro/saques-gestao', icon: Banknote, badge: N },
      { label: 'Log de Auditoria', path: '/financeiro/auditoria', icon: ScrollText, badge: N },
    ],
  },
  {
    section: 'Simulações',
    items: [{ label: 'Simulações', path: '/simulacoes', icon: Calculator }],
  },
  {
    section: 'Sistema',
    items: [
      { label: 'Usuários', path: '/sistema/usuarios', icon: UserCog },
      { label: 'Funcionários', path: '/funcionarios', icon: IdCard },
      { label: 'Plano de Carreira', path: '/sistema/qualificacoes', icon: Award, badge: N },
      { label: 'Motor de Remuneração', path: '/sistema/motor-remuneracao', icon: DollarSign, badge: N },
      { label: 'Simulador do Motor', path: '/sistema/simulador-motor', icon: Calculator, badge: N },
      { label: 'Termos e Documentos', path: '/sistema/termos', icon: FileText, badge: N },
      { label: 'Parâmetros MLM', path: '/sistema/parametros', icon: SlidersHorizontal, badge: N },
      { label: 'Kits de Recrutamento', path: '/sistema/kits', icon: Wallet, badge: N },
      { label: 'Campanhas & Incentivos', path: '/incentivos', icon: Trophy, badge: N },
      { label: 'Fundo de Incentivo', path: '/fundo', icon: Landmark, badge: N },
      { label: 'Central de Notificações', path: '/notificacoes/central', icon: Megaphone, badge: N },
      { label: 'Templates de Notificação', path: '/notificacoes/templates', icon: Mail, badge: N },
      { label: 'Minhas Notificações', path: '/notificacoes', icon: Bell, badge: N },
      { label: 'Suporte / Tickets', path: '/suporte', icon: LifeBuoy, badge: N },
    ],
  },
  {
    section: 'Rede',
    items: [
      { label: 'Link de Indicação', path: '/indicacao', icon: Share2 },
      { label: 'Minha Rede', path: '/rede', icon: Network },
      { label: 'Meu Link / Loja', path: '/meu-link', icon: Store, badge: N },
    ],
  },
  {
    section: 'Relatórios',
    items: [
      { label: 'Crescimento & BI', path: '/crescimento', icon: BarChart3, badge: N },
      { label: 'Tempo de Cadastro', path: '/relatorios/tempo-cadastro', icon: ScrollText, badge: N },
      { label: 'Extrato de Pontos', path: '/relatorios/pontos', icon: Trophy, badge: N },
      { label: 'Extrato', path: '/relatorios/extrato', icon: Receipt },
      { label: 'Comissões', path: '/relatorios/comissoes', icon: DollarSign },
    ],
  },
  {
    section: 'Material de Apoio',
    items: [
      { label: 'Universidade Corporativa', path: '/universidade', icon: GraduationCap, badge: N },
      { label: 'Materiais', path: '/material', icon: BookOpen },
      { label: 'Gerador de Flyer', path: '/flyer', icon: Image, badge: N },
    ],
  },
  {
    section: 'Integrações',
    items: [
      { label: 'IA TheConect 360°', icon: Sparkles, path: '/sistema/ia', badge: 'config' },
      { label: 'Integração Asaas', path: '/integracoes/asaas', icon: CreditCard, badge: N },
      { label: 'Meio de Pagamento', path: '/integracoes/pagamento', icon: CreditCard },
      { label: 'Parcelamento', path: '/integracoes/parcelamento', icon: CreditCard, badge: N },
      { label: 'Sessão WhatsApp', path: '/integracoes/whatsapp', icon: MessageCircle },
      { label: 'Email Sistema', path: '/integracoes/email', icon: Mail },
      { label: 'APIs do Sistema', path: '/integracoes/apis', icon: Plug },
    ],
  },
]

const LICENCIADO = [
  {
    section: 'Minha Operação',
    items: [
      { label: 'Clientes', path: '/clientes', icon: Users },
      { label: 'Minhas Simulações', path: '/simulacoes', icon: Calculator },
    ],
  },
  {
    section: 'Loja & Vendas',
    items: [
      { label: 'Painel de Vendas', path: '/vendas/painel', icon: BarChart3, badge: N },
      { label: 'Fazer Pedidos', path: '/registros/pedidos', icon: ShoppingCart, badge: N },
      { label: 'Meu Link / Loja', path: '/meu-link', icon: Store, badge: N },
    ],
  },
  {
    section: 'Registros de Conexão',
    items: [
      { label: 'Nova Conexão', path: '/registros/conexao', icon: Link2 },
      { label: 'Minhas Conexões', path: '/registros/minhas-conexoes', icon: ClipboardList, badge: N },
      { label: 'Proteção Veicular', path: '/registros/protecao-veicular', icon: ShieldCheck, badge: N },
      { label: 'Telecom', path: '/registros/telecom', icon: Smartphone, badge: N },
    ],
  },
  {
    section: 'Financeiro',
    items: [
      { label: 'Minha Carteira', path: '/financeiro/carteira', icon: Wallet, badge: N },
      { label: 'Meus Ganhos', path: '/relatorios/comissoes', icon: DollarSign },
      { label: 'Extrato de Pontos', path: '/relatorios/pontos', icon: Trophy, badge: N },
      { label: 'Extrato', path: '/relatorios/extrato', icon: Receipt },
    ],
  },
  {
    section: 'Rede',
    items: [
      { label: 'Rede e Bônus', path: '/rede', icon: Network },
      { label: 'Crescimento & BI', path: '/crescimento', icon: BarChart3, badge: N },
      { label: 'Link de Indicação', path: '/indicacao', icon: Share2 },
      { label: 'Campanhas & Ranking', path: '/incentivos', icon: Trophy },
    ],
  },
  {
    section: 'Apoio',
    items: [
      { label: 'IA TheConect 360°', icon: Sparkles, action: 'ia', badge: 'Ctrl+X' },
      { label: 'Notificações', path: '/notificacoes', icon: Bell, badge: N },
      { label: 'Universidade Corporativa', path: '/universidade', icon: GraduationCap, badge: N },
      { label: 'Materiais de Apoio', path: '/material', icon: BookOpen },
      { label: 'Meus Documentos', path: '/meus-documentos', icon: FileText, badge: N },
      { label: 'Gerador de Flyer', path: '/flyer', icon: Image, badge: N },
      { label: 'Suporte', path: '/suporte', icon: LifeBuoy },
    ],
  },
]

const CLIENTE = [
  {
    section: 'Minha Conta',
    items: [{ label: 'Meus Dados', path: '/cadastro/clientes', icon: Users }],
  },
  {
    section: 'Loja',
    items: [{ label: 'Fazer Pedidos', path: '/registros/pedidos', icon: ShoppingCart, badge: N }],
  },
  {
    section: 'Apoio',
    items: [
      { label: 'Materiais', path: '/material', icon: BookOpen },
      { label: 'Suporte', path: '/suporte', icon: LifeBuoy },
    ],
  },
]

export const MENUS = { admin: ADMIN, licenciado: LICENCIADO, cliente: CLIENTE }

// ─────────── PRÉ-LICENCIADO (licença ainda não paga) — acesso LIMITADO (PRD) ───────────
// Só pode ACESSAR estas rotas (visualização). Todo o resto é bloqueado até ativar a licença.
export const PRE_LICENCIADO_ALLOW = [
  '/dashboard',            // Dashboard de apresentação
  '/universidade',         // Plano de Negócios / vídeos de treinamento
  '/material',             // Materiais de apoio / marketing
  '/rede',                 // Minha Rede (SOMENTE CONSULTA — PRD 05-08-26)
  '/incentivos',           // Campanhas (visualização)
  '/incentivos/:id',       // Campanha (página completa)
  '/suporte',              // Perguntas frequentes / suporte
  '/notificacoes',         // Central de Notificações
  '/meus-documentos',      // Termos e documentos (aceite)
  '/minha-conta',          // Perfil + alteração de senha + acompanhamento do pagamento
  '/completar-cadastro',
]

// Menu enxuto do pré-licenciado (somente o permitido) + CTA de finalizar licença.
export const PRE_LICENCIADO_MENU = [
  {
    section: 'Minha Licença',
    items: [
      { label: 'Finalizar Pagamento', path: '/minha-conta', icon: CreditCard, badge: 'pague' },
    ],
  },
  {
    section: 'Conheça a Plataforma',
    items: [
      { label: 'Universidade Corporativa', path: '/universidade', icon: GraduationCap },
      { label: 'Plano de Negócios / Materiais', path: '/material', icon: BookOpen },
      { label: 'Minha Rede (consulta)', path: '/rede', icon: Network },
      { label: 'Campanhas', path: '/incentivos', icon: Trophy },
    ],
  },
  {
    section: 'Apoio',
    items: [
      { label: 'Notificações', path: '/notificacoes', icon: Bell },
      { label: 'Suporte / FAQ', path: '/suporte', icon: LifeBuoy },
      { label: 'Meu Perfil', path: '/minha-conta', icon: UserCog },
    ],
  },
]

export function podeAcessarPreLicenciado(path) {
  return PRE_LICENCIADO_ALLOW.includes(path)
}

// Rotas SEM item de menu (acessadas por navegação interna) — precisam estar aqui p/ o App registrar.
const EXTRA_ROUTES = [
  { label: 'PV — Nova Cotação', path: '/registros/protecao-veicular/nova', icon: ShieldCheck },
  { label: 'Completar Cadastro', path: '/completar-cadastro', icon: UserCog },
  { label: 'Campanha (detalhe)', path: '/incentivos/:id', icon: Trophy },
]

// Todas as rotas únicas (para registrar no App, independente do perfil).
export const ALL_ITEMS = [
  DASHBOARD_ITEM,
  ...[...ADMIN, ...LICENCIADO, ...CLIENTE].flatMap((s) => s.items),
  ...EXTRA_ROUTES,
]
